import { Component,ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-file-upload',
  template: `
  <p-fileUpload name="files[]"  [maxFileSize]="	26214400 " invalidFileSizeMessageSummary='{0}' invalidFileSizeMessageDetail = 'Max upload file size is {0}.' [customUpload]="customUpload" [showUploadButton]="false" chooseLabel="Upload Files" [auto]="true" [files]="ListOfFiles" [showCancelButton]="showCancelButton" [showUploadButton]="uploadIdExists" (onRemove)="onRemove($event)" (uploadHandler)="onUpload($event)" [multiple]='multiple' #fileInput>
      <ng-template let-file pTemplate="file">
        <div class="filesCnt">
          <span style='margin-right:5px;'>{{file.name || file.Originalname}}</span>
          <span><i class="fas fa-times" aria-hidden="true" (click)="removeFile($event,file)"></i></span>
        </div>
      </ng-template>
    </p-fileUpload>
  `,
  styleUrls: ['./file-upload.component.less']
})
export class FileUploadComponent extends FieldType {
  formControl!: FormControl;
  uploadedFiles = [];
  @ViewChild('fileInput') fileInput!: FileUpload;
  constructor() {
    super();
  }

  get ListOfFiles() {
    if (this.model['' + (this.key)]) {
      return this.model['' + (this.key)];
    } else if (this.fileInput) {
      return this.fileInput.files;
    }
    return [];
  }

  onUpload($event: any) {
    if (this.to.onUpload) {
      this.to.onUpload($event, this.fileInput);
    }
  }

  onRemove($event: any) {
    if (this.to.onRemove) {
      this.to.onRemove($event);
    }
  }

  public get multiple(): boolean {
    if (this.to.multiple) return this.to.multiple; else return true;
  }

  get customUpload(): boolean {
    return true;
  }

  get showCancelButton(): boolean {
    return false;
  }

  removeFile(event: Event, file: File) {
    const files = this.fileInput['files'];
    const index = files.indexOf(file);
    this.fileInput.files.splice(index, 1);
    // console.log(this.fileInput);
    /* const index = uploader.files.indexOf(file);
    uploader.remove
    uploader.remove(event, index); */
  }

  get uploadIdExists() {
    if (!this.fileInput) {
      return false;
    }
    const files = this.fileInput.files.filter(file => (file.hasOwnProperty("UploadId")));
    return !(files.length === this.fileInput.files.length);
  }


  /* removeFile(file: File, uploader: FileUpload) {
    const index = uploader.files.indexOf(file);
    uploader.remove(null, index);
  } */
}


/**
 *     <div class="drop-area">
        <div>{{ 'LblDragDrop' | translate }}</div>
        <input type="file" [formControl]="formControl" [formlyAttributes]="field" />
    </div>
    <div class="file-name" *ngIf="model['' + this.key]">
      {{model['' + this.key][0].name}}
    </div>

    ==== Another One ====
    <div class="file has-name is-boxed">
      <label class="file-label">
        <input class="file-input" type="file" [formControl]="formControl" [formlyAttributes]="field">
        <span class="file-cta">
          <span class="file-icon">
            <i class="fas fa-upload"></i>
          </span>
          <span class="file-label">
            Choose a file…
          </span>
        </span>
        <span class="file-name" *ngIf="model['' + this.key]">
          {{model['' + this.key][0].name}}
        </span>
      </label>
    </div>
 */